export default function getDefaultState() {
  return {
    cancellationReviews: {},
    totalCancellationReviews: 0,
    cancellationReviewsLoading: true,
  };
}
